import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
var _ref = /*#__PURE__*/React.createElement(Icon, {
  name: "arrowDropDown",
  size: "large"
});
export default /*#__PURE__*/React.memo(function (props) {
  return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, _ref);
});